var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('DashHeader'),_c('Siderbar'),_c('div',{staticClass:"content-wrapper"},[_c('ContentHeader'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }